// extracted by mini-css-extract-plugin
export var productLine = "prodcut-module--product-line--2Glco";
export var imageWrapper = "prodcut-module--image-wrapper--2Nnqv";
export var name = "prodcut-module--name--3z6GM";
export var productMain = "prodcut-module--product-main--3PJKM";
export var cardWrapper = "prodcut-module--card-wrapper--pJwcW";
export var cardImg = "prodcut-module--card-img--uEK0x";
export var cardBody = "prodcut-module--card-body--39lhH";
export var navItem = "prodcut-module--nav-item--1th6K";
export var navBody = "prodcut-module--nav-body--2KFDN";